/*
Input: Javascript object like MusterGraph
Output: an object with the tree centered to user object (data owner) AND a relations array
{
  tree: {
    id: ...,
    value: ...,
    content: [obj1, obj2,...]
    properties: {
      firstName: "...",
      lastName: "...",
    }
  },
  relations: [
    { from: "h1-1", to "h1-11-4", title: "restingHeartRate" },
    { from: "h1-1-4", to: "h1-1-4-1" },
     ...
  ]
}

if object has a content and content length > 0, then it is a folder
otherwise it is a file
*/
import { mergeSetsToFirst } from "../../utils/sets";
import { findRootNode2, RELATION_META2, TYPE_FILE2, TYPE_FOLDER2, RELATION_BRIDGE_LINK, } from "../../utils/graph/graphmodifier2";
import { findFileSystemRoot2 } from "../../utils/graph/graphstorage2";
import { ensureAuxStructures2 } from "../../utils/graph/graphauxcreator2";
/*interface TreeEdge {
  from: number;
  to: number;
  title: string;
}*/
export function graphProcessor(processedGraph) {
    const realNodes = processedGraph.nodes; // returns nodes array [ { id: 1, type: "dwin://node/core/dataOwner" }, ...]
    const dataOwnerNodeId = getDataOwnerId(processedGraph); // 1071
    const idToTreeNodeObjMap = makeIdToNodeMap(realNodes); // { "dof-1": {id:"dof-1", value: "Health", content: [], tags: [], properties: {}}, "dof-2": {id:"dof-2", value:..., content: [], tags: ["health", "fitness"], properties: {}} };
    const cidToCategoryNameMap = makeCidToCategoryNameMap(processedGraph);
    const returnTree = makeTree(processedGraph.edges, idToTreeNodeObjMap, dataOwnerNodeId, cidToCategoryNameMap); // returns { id: "do123", value: "Health", content: [obj1, obj2,...], tags: ["health", "fitness"], properties: {}};
    //const relations = transformRelations(processedGraph.edges);
    const result = { tree: returnTree }; //, relations: relations };
    //console.log("tree:", returnTree);
    return result;
}
export function getDataOwnerFilesObj(retValueTree) {
    return retValueTree.content.find((child) => child.value === "dataOwnerFiles"); // TODO ez már nem jó!!!!
}
export function collectContentTypesFromTree(root) {
    const contentTypes = new Set();
    if (root !== undefined) {
        if (root.properties.fileMimeType !== "") {
            contentTypes.add(root.properties.fileMimeType);
        }
        for (const child of root?.content ?? []) {
            const childContentTypesSet = collectContentTypesFromTree(child);
            mergeSetsToFirst(contentTypes, childContentTypesSet);
        }
        contentTypes.delete(undefined);
    }
    return contentTypes;
}
export function collectTagsFromTree(root) {
    let tagsSet = new Set();
    if (root !== undefined) {
        tagsSet = mergeSetsToFirst(tagsSet, new Set(root.tags));
        for (const child of root?.content ?? []) {
            const childTagsSet = collectTagsFromTree(child);
            tagsSet = mergeSetsToFirst(tagsSet, childTagsSet);
        }
        tagsSet.delete(undefined);
    }
    return tagsSet;
}
export const exampleFiles = {
    entries: [
        {
            creationTime: 1729765946,
            isFile: true,
            metadata: {
                "Content-Type": "image/png",
            },
            path: "/f1/f2/good_car.png",
            size: 794010,
        },
        {
            creationTime: 1729765908,
            isFile: true,
            metadata: {
                "Content-Type": "image/jpeg",
            },
            path: "/IMG_20200318_161512.jpg",
            size: 5008311,
        },
        {
            creationTime: 1729765906,
            isFile: true,
            metadata: {
                "Content-Type": "image/jpeg",
            },
            path: "/f1/strawberry.jpg",
            size: 89484,
        },
        {
            creationTime: 1729765907,
            isFile: true,
            metadata: {
                "Content-Type": "image/png",
            },
            path: "/f1/f3/card_deck_20200406.png",
            size: 494898,
        },
    ],
};
function getDataOwnerId(processedGraph) {
    const dataOwnerNode = findFileSystemRoot2(processedGraph);
    if (dataOwnerNode === undefined) {
        throw new Error("Error in data file: no data owner found");
    }
    return dataOwnerNode.id;
}
function makeIdToNodeMap(realNodes) {
    const retValue = {};
    for (const realNode of realNodes) {
        retValue[realNode.id] = createTreeNodeFromRealGraphNode(realNode);
    }
    return retValue;
}
function createTreeNodeFromRealGraphNode(realGraphNode) {
    //console.log("createTreeNodeFromRealGraphNode", realGraphNode);
    const newTreeNode = {
        id: realGraphNode.id,
        cid: realGraphNode.cid,
        value: realGraphNode.label,
        readonly: realGraphNode.readonly,
        content: [],
        tags: [],
        properties: {
            creationTime: realGraphNode.properties?.createdAt
                ?? Math.floor(new Date(realGraphNode._created).getTime() / 1000),
            fileName: realGraphNode.properties?.fileName,
            fileSize: realGraphNode.properties?.fileSize,
            fileMimeType: realGraphNode.properties?.fileMimeType,
            fileStorageId: realGraphNode.properties?.fileStorageId,
        },
    };
    if (realGraphNode._type === TYPE_FILE2) {
        newTreeNode.properties.isFile = true;
    }
    else if (realGraphNode._type === TYPE_FOLDER2) {
        newTreeNode.properties.isFile = false;
    }
    return newTreeNode;
}
export function makeCidToCategoryNameMap(processedGraph) {
    const cidToRootNodeLabelMap = {};
    const rootNode = findRootNode2(processedGraph);
    ensureAuxStructures2(processedGraph);
    const edgesFromRoot = processedGraph.aux?.getEdgesByFrom(rootNode.id) ?? [];
    for (const edge of edgesFromRoot) {
        const categoryRootNode = processedGraph?.aux?.getNodeById(edge.to);
        if (categoryRootNode === undefined) {
            continue;
        }
        cidToRootNodeLabelMap[categoryRootNode.cid] = categoryRootNode.label;
    }
    return cidToRootNodeLabelMap;
}
function makeTree(graphObjRelations, idToNodeObjMap, dataOwnerNodeId, cidToCategoryNameMap) {
    //console.log("cid=>label", cidToRootNodeLabelMap);
    for (const edge of graphObjRelations) {
        const sourceObj = idToNodeObjMap[edge.from];
        const targetObj = idToNodeObjMap[edge.to];
        if (sourceObj !== undefined && targetObj !== undefined) {
            if (edge._type === RELATION_META2 || edge._type === RELATION_BRIDGE_LINK) {
                const tagName = cidToCategoryNameMap[sourceObj.cid];
                if (!targetObj.tags.includes(tagName)) {
                    targetObj.tags.push(tagName);
                }
            }
            else {
                sourceObj.content.push(targetObj);
            }
        }
    }
    return idToNodeObjMap[dataOwnerNodeId];
}
/*function transformRelations(graphObjRelations: Array<Edge2>) {
  const newRelations = [];
  for (let i = 0; i < graphObjRelations.length; i++) {
    const newRel: TreeEdge = { from: graphObjRelations[i].from, to: graphObjRelations[i].to, title: "N/A" };
    const relName = graphObjRelations[i]._type;
    // TODO átnézni
    if (!relName.endsWith("contains") && !relName.endsWith("has")) {
      const relNameParts = relName.split("/");
      newRel.title = relNameParts[relNameParts.length - 1];
    }
    newRelations.push(newRel);
  }
  return newRelations;
}*/
